// Debug utility to check environment configuration
export const debugEnvironmentConfig = () => {
  const config = {
    mode: import.meta.env.MODE,
    apiUrl: import.meta.env.VITE_API_URL,
    googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    appUrl: import.meta.env.VITE_APP_URL,
    currentOrigin: window.location.origin,
    currentHostname: window.location.hostname,
    isProduction: import.meta.env.PROD,
    isDevelopment: import.meta.env.DEV,
  };

  console.log('🔧 Environment Configuration:', config);
  
  // Always log in production for debugging
  if (import.meta.env.PROD) {
    console.log('🚀 Production Environment Detected');
    console.log('📡 API URL:', config.apiUrl);
    console.log('🌐 Current Origin:', config.currentOrigin);
  }
  
  return config;
};

// Function to validate Google OAuth configuration
export const validateGoogleConfig = () => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  const currentOrigin = window.location.origin;
  
  if (!clientId) {
    console.error('❌ VITE_GOOGLE_CLIENT_ID no está configurado');
    return false;
  }

  console.log('✅ Google Client ID configurado:', clientId.substring(0, 10) + '...');
  console.log('🌐 Current Origin:', currentOrigin);
  
  return true;
};

// Function to validate API configuration
export const validateApiConfig = () => {
  const apiUrl = import.meta.env.VITE_API_URL;
  
  if (!apiUrl) {
    console.error('❌ VITE_API_URL no está configurado');
    return false;
  }

  console.log('✅ API URL configurado:', apiUrl);
  
  // Check if it's pointing to localhost in production
  if (import.meta.env.PROD && apiUrl.includes('localhost')) {
    console.error('❌ API URL apunta a localhost en producción:', apiUrl);
    return false;
  }
  
  return true;
}; 